import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { ButtonV2, dsV2 } from '@bloomays-lib/ui.shared';

/** Titre Instrument Serif (toolbar, hero, popins). */
export const SerifTitle = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Box
    component="span"
    sx={{
      fontFamily: dsV2.font.serif,
      fontWeight: 400,
      lineHeight: 1.1,
      letterSpacing: '-0.02em',
      color: dsV2.color.noir,
      ...sx,
    }}
  >
    {children}
  </Box>
);

/** En-tête de section (créa `.section-label`) : libellé Instrument + trait de séparation à droite. */
export const SectionLabel = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '22px', marginBottom: '10px', ...sx }}>
    <SerifTitle sx={{ fontSize: 17, whiteSpace: 'nowrap' }}>{children}</SerifTitle>
    <Box sx={{ flex: 1, height: '1px', background: dsV2.color.borderLight }} />
  </Box>
);

/** Skeleton de section (chargement progressif) — surface arrondie de la charte V2. */
export const Skel = ({ height = 160 }: { height?: number }) => (
  <Skeleton
    variant="rounded"
    width="100%"
    height={height}
    sx={{ borderRadius: dsV2.radius.lg, bgcolor: dsV2.color.surface2 }}
  />
);

/**
 * Bouton « fantôme » bleu doux — actions d'en-tête de carte.
 * Délègue à `ButtonV2 variant="ghost"` (source unique de vérité boutons DS V2).
 */
export const GhostButton = ({ children, onClick }: { children: React.ReactNode; onClick?: () => void }) => (
  <ButtonV2 variant="ghost" size="small" onClick={onClick}>
    {children}
  </ButtonV2>
);
